import { useContextBarAppearance } from "@/contexts/ContextBarAppearanceContext";
import { cn } from "@/lib/utils";

type NoItemProps = {
    text: string;
};

const NoItem = ({ text }: NoItemProps) => {
    const { isDeepFocus } = useContextBarAppearance();

    return (
        <p
            className={cn(
                "px-4 text-left text-sm",
                isDeepFocus && "text-white",
            )}
        >
            {text}
        </p>
    );
};

export default NoItem;
